
import layout from './frontLayout'
import form from './form'
import model from './model'
import { C } from 'xadmin-ui'

import './mobile.css'

export default {
  name: 'gtiot.ui',
  components: {
    ...model.components,
    ...layout.components,
    ...form.components,
  },
  form_fields: {
    ...form.form_fields
  },
  modelActions: {
    modalEdit: {
      default: false, component: C.lazy('Model.ActionModalEdit')
    },
    modalView: {
      default: false, component: C.lazy('Model.ActionModalView')
    },
    exportPDF: {
      default: false, component: props => <C is="Model.ActionModalView" {...props} pdf name="导出PDF" />
    }
  },
}
